.group {
    display: grid;
    grid-gap: 10px;
    position: relative;
    width: 100%;

    & > div {
        min-width: 0;
        max-width: 100%;
    }
}
